import { cloneVNode, type VNode, Fragment, isVNode, toValue } from "vue";

import { useNavigator } from "../components/navigator";

/**
 * The Command component is responsible to forward event handlers to slots' nodes
 */
export default {
  setup(_props, { slots, attrs }) {
    const patchVnodes = (vnodes: VNode | VNode[], attrs) =>
      (Array.isArray(vnodes) ? vnodes : [vnodes]).flatMap((vnode) =>
        patchVnode(vnode, attrs)
      );

    function patchVnode(vnode: VNode | unknown, attrs): VNode | VNode[] {
      if (!isVNode(vnode)) {
        return vnode as VNode;
      }
      if (vnode.type === Fragment) {
        return patchVnodes(vnode.children as VNode[], attrs);
      }
      return cloneVNode(vnode, attrs);
    }

    const filterListeners = (attrs) =>
      Object.fromEntries(
        Object.entries(attrs).filter(([key]) => key.startsWith("on"))
      );

    const navigator = useNavigator();

    return () =>
      // don't render buttons until navigator instance is ready
      toValue(navigator)
        ? patchVnodes(slots.default?.() ?? [], filterListeners(attrs))
        : null;
  },
};
